export const localStorage = {
  set: (key, value) => {
    if (typeof key === undefined || typeof value === undefined) { return; }

    const stringValue = typeof value !== "string" ? JSON.stringify(value) : value;
    try {
      window.localStorage.setItem(key, stringValue);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to SET localStorage [${key}]: ${error}`);
    }
  },
  get: key => {
    if (typeof key === undefined) { return null; }

    let resultData = null;

    try {
      resultData = window.localStorage.getItem(key);
      resultData = JSON.parse(resultData);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to GET localStorage [${key}]: ${error}`);
    }

    return resultData;
  },
  remove: key => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to REMOVE localStorage [${key}]: ${error}`);
    }
  }
};

export const sessionStorage = {
  set: (key, value) => {
    if (typeof key === undefined || typeof value === undefined) { return; }

    const stringValue = typeof value !== "string" ? JSON.stringify(value) : value;
    try {
      window.sessionStorage.setItem(key, stringValue);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to SET sessionStorage [${key}]: ${error}`);
    }
  },
  get: key => {
    if (typeof key === undefined) { return null; }

    let resultData = null;

    try {
      resultData = window.sessionStorage.getItem(key);
      resultData = JSON.parse(resultData);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to GET sessionStorage [${key}]: ${error}`);
    }

    return resultData;
  },
  remove: key => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.warn(`Try to REMOVE sessionStorage [${key}]: ${error}`);
    }
  }
};